import { Injectable } from '@angular/core';
import { BaseApi } from './base/base-api';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root',
})
export class ApiCallLogApiService extends BaseApi {
  constructor() {
    super(environment.api + 'ApiCallLog');
  }

  public downloadApiCallLogs(): Observable<Blob> {
    return this.http.get(this.baseUrl + '/download-csv', { responseType: 'blob' });
  }
}
